module.exports = __webpack_public_path__ + "img/check.411db03a.svg";